import React, { memo } from 'react'
import { Banner } from '../../../../../../../../components/Banner/desktop'
import { usePaidPackage } from '../../../bll/usePaidPackage'
import { IProgramIdBannerProps } from '../types'

const ProgramIdBanner = memo(({ programTypes }: IProgramIdBannerProps) => {
  const hasPaidPackage = usePaidPackage()

  if (!hasPaidPackage) {
    return (
      <>
        <Banner
          id={6}
          extraParams={
            programTypes
              ? {
                  'programTypes[]': [programTypes],
                }
              : undefined
          }
        />

        <Banner
          id={14}
          extraParams={
            programTypes
              ? {
                  'programTypes[]': [programTypes],
                }
              : undefined
          }
        />
      </>
    )
  }

  return null
})

export default ProgramIdBanner
